import hiddenComponent from "../components/hidden";
import inputComponent from "../components/input";
import radioComponent from "../components/radio";
import checkboxComponent from "../components/checkbox";
import switchComponent from "../components/switch";
import selectComponent from "../components/select";
import datePickerComponent from "../components/datePicker";
import timePickerComponent from "../components/timePicker";
import inputNumberComponent from "../components/inputNumber";
import colorPickerComponent from "../components/colorPicker";
import uploadComponent from "../components/upload";
import cascaderComponent from "../components/cascader";
import rateComponent from "../components/rate";
import sliderComponent from "../components/slider";
import frameComponent from "../components/frame";
import treeComponent from "../components/tree";
import autoCompleteComponent from "../components/autoComplete";


const componentList = {
    hidden: hiddenComponent,
    input: inputComponent,
    radio: radioComponent,
    checkbox: checkboxComponent,
    switch: switchComponent,
    select: selectComponent,
    datepicker: datePickerComponent,
    timepicker: timePickerComponent,
    inputnumber: inputNumberComponent,
    colorpicker: colorPickerComponent,
    upload: uploadComponent,
    cascader: cascaderComponent,
    rate: rateComponent,
    slider: sliderComponent,
    frame: frameComponent,
    tree: treeComponent,
    autocomplete: autoCompleteComponent,
};

export default componentList
